import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "video", "caption", "item"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  open(event) {
    const item = event.currentTarget
    this.overlayTarget.classList.remove("hidden")
    this.videoTarget.src = item.dataset.videoLightboxSrc
    this.captionTarget.textContent = item.dataset.videoLightboxCaption
    this.trackPlay(item.dataset.videoLightboxPlayEventUrl)
    this.videoTarget.play().catch(() => {})
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.videoTarget.pause()
    this.videoTarget.removeAttribute("src")
    this.videoTarget.load()
    this.captionTarget.textContent = ""
    document.removeEventListener("keydown", this.handleKeydown)
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  trackPlay(url) {
    if (!url) {
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const headers = { "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml" }

    if (csrfToken) {
      headers["X-CSRF-Token"] = csrfToken
    }

    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers
    }).catch(() => {})
  }
}
